import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/JobsTable/component'

export const JobsTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
